import {IBusinessObject, IBusinessObjectChanges, IBusinessObjectChangesOptions} from '../PA.Core/PA.Core.IF.BO';
import {IMessageProvider, IProgressProvider, MessageType} from '../PA.Core/PA.Core.IF.Basic';
import {PAdbContext} from '../PA.Core/PAdbContext';
import {IdentityProvider} from "../PA.Core/Basic/Identity";
import {
  WB_CustomerRow, WB_DistribChannelRow, WB_DivisionRow,
  WB_DomainItemRow, WB_MasterDataSetRow, WB_ProductGroupRow, WB_ProductHierarchyRow, WB_SalesAreaRow, WB_SalesOrgRow,
  WB_UserGroupCustomerRow, WB_UserGroupProductRow, WB_UserGroupRelationshipRow,
  WB_UserGroupRoleRow,
  WB_UserGroupRow, WB_UserGroupSalesAreaRow, WB_UserGroupTypeRow,
  WB_UserGroupUserRow,
  WB_UserRow
} from "../PA.Core/PAdbSchemaRows";
import {ProgressProvider} from "../PA.Core/Basic/Progress";
import {MessageProvider} from "../PA.Core/Basic/Messages";
import {
  esWB_Customer, esWB_Customer_SalesArea_Relationship,
  esWB_DistribChannel,
  esWB_Division,
  esWB_Domain_Item,
  esWB_MasterData_Set,
  esWB_Modeling_Session_Trial,
  esWB_Modeling_Session_Trial_Metric,
  esWB_Modeling_Session_Trial_Predictor_Metric,
  esWB_Modeling_Session_Trial_PredictorR_Metric,
  esWB_Product_Group,
  esWB_SalesArea,
  esWB_SalesOrg,
  esWB_User,
  esWB_User_Group,
  esWB_User_Group_Customer,
  esWB_User_Group_Product,
  esWB_User_Group_Relationship,
  esWB_User_Group_Role,
  esWB_User_Group_SalesArea,
  esWB_User_Group_Type,
  esWB_User_Group_User
} from "../PA.Core/PAdbSchema";
import {ASync} from "../PA.Core/Basic/ASync";
import {CreateOptions, ESRecordResolver} from "../PA.Core/lib/ESRecordResolver";
import {IwbUserGroup} from "../PA.Core/PAdbSchemaRowsIF";
import {ESRecord} from "../PA.Core/lib/ESRecord";
import {ESDataStore} from "../PA.Core/lib/ESDataStore";
import {UserGroupBOAudit} from "./UserGroupBO.Audit";
import {UserGroupBOValidations} from "./UserGroupBO.Validations"
import _ = require('lodash');
import {LeaseRegistry} from "../PA.Utils/LeaseRegistry";
import {AuditService} from "../PA.Core/Security/AuditService";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {BehaviorSubject} from "rxjs";
import {DefaultChanges} from "../PA.Core/BusinessObject/BusinessObjectChanges";


export interface IUserGroupCreateOptions{
  dbContext?: PAdbContext,
  sName?: string,
  USRGRPM_ID?: string,
  wbUserGroupTypeID?: number,
  wbSalesOrgId?: number
}


const UserGroupLoadOptions_default: IUserGroupCreateOptions = {}

export class UserGroupBO implements IBusinessObject {

  Identity: IdentityProvider;


  CreateOptions: IUserGroupCreateOptions;

  LoadOptions: IUserGroupCreateOptions;
  _bIsLoaded: boolean;
  _OnLoadComplete: Promise<IBusinessObject>;
  LoadProgressProvider: IProgressProvider;

  ValidateOptions: any;
  _bIsValidated: boolean;
  ValidateMessageProvider: IMessageProvider;
  ValidateProgressProvider: IProgressProvider;

  SaveOptions: any;
  _bIsSaved: boolean;
  SaveProgressProvider: IProgressProvider;

  DeleteOptions: any;
  _bIsDeleted: boolean;
  DeleteMessageProvider: IMessageProvider;
  DeleteProgressProvider: IProgressProvider;

  dbContext: PAdbContext;
  drWB_UserGroup: WB_UserGroupRow;

  dctAuditedDeletes: {[id:number]: number}
  constructor(options?: IUserGroupCreateOptions) {

    this.CreateOptions = options || {};

    if ('dbContext' in this.CreateOptions)
      this.dbContext = this.CreateOptions.dbContext;

    this.Identity = new IdentityProvider({id: 0, name: 'New User Group'});

    this.LoadOptions = {};
    this._bIsLoaded = false;
    this._OnLoadComplete = undefined;
    this.LoadProgressProvider = new ProgressProvider('Loading', this);

    this.ValidateOptions = {};
    this._bIsValidated = false;
    this.ValidateMessageProvider = new MessageProvider();
    this.ValidateProgressProvider = new ProgressProvider("Validating", this);

    this.SaveOptions = {};
    this._bIsSaved = false;
    this.SaveProgressProvider = new ProgressProvider("Saving", this);

    this.DeleteOptions = {};
    this._bIsDeleted = false;
    this.DeleteMessageProvider = new MessageProvider();
    this.DeleteProgressProvider = new ProgressProvider("Deleting", this);

    this.drWB_UserGroup = undefined;

    this.dctAuditedDeletes = {}
    this.IHaveSalesAreas_init()

  }

  get WB_UserGroup(): WB_UserGroupRow {
    return this.drWB_UserGroup;
  }

  //<editor-fold desc = "User Role Operations">

  addRole(aWbRoleId: number): Promise<IBusinessObject> {
    const self = this

    return new Promise<IBusinessObject>((resolve, error) => {

      // first find out if record exists.
      var found = false

      _.forEach(self.drWB_UserGroup.WB_UserGroupRoleRows, (aUsrGrpRoleRelRow: WB_UserGroupRoleRow) => {
        if (aUsrGrpRoleRelRow.isActive && aUsrGrpRoleRelRow.cif.WB_DOMITEM_ID == aWbRoleId) {
          found = true
          return false
        }
      })

      if (found) {
        resolve(self);
        return;
      } // exists..
      var aDomainItemRow: WB_DomainItemRow = undefined
      // var aUserGroupRoleRow: WB_UserGroupRoleRow = undefined esWB_Domain_Item

      //self.dbContext.find(esWB_User_Group_Role, aWbRoleId)
      self.dbContext.find(esWB_Domain_Item, aWbRoleId)
        .then((aRoleRecord: WB_UserGroupRoleRow) => {
          if (_.isEmpty(aRoleRecord)) {
            // Bad User Role Id...
            resolve(self)
            return
          }
          aDomainItemRow = aRoleRecord

          // create new records
          return self.dbContext.createRecordWithKey(esWB_User_Group_Role)

        })
        .then((aNewRow: WB_UserGroupRoleRow) => {
          aNewRow.cif.WB_USRGRP_ID = self.drWB_UserGroup.cif.WB_USRGRP_ID
          aNewRow.cif.WB_DOMITEM_ID = aDomainItemRow.cif.WB_DOMITEM_ID
          aNewRow.cif.WB_CUST_ID = 0
          aNewRow.WB_DomainItemRow_Role = aDomainItemRow
          self.dbContext.add(esWB_User_Group_Role, aNewRow)
          resolve(self)
        })
        .catch((err) => {
          error(err)
        })
    })
  }

  removeRole(aWbRoleId: number): Promise<IBusinessObject> {
    const self = this

    return new Promise<IBusinessObject>((resolve, error) => {

      _.forEach(self.drWB_UserGroup.WB_UserGroupRoleRows, (aUsrGrpRoleRelRow: WB_UserGroupRoleRow) => {
        if (aUsrGrpRoleRelRow.isActive && aUsrGrpRoleRelRow.cif.WB_DOMITEM_ID == aWbRoleId) {
          aUsrGrpRoleRelRow.markDeleted()
        }
      })

      resolve(self)
    })
  }

  addCustomer(aWbCustId: number): Promise<IBusinessObject> {
    const self = this

    return new Promise<IBusinessObject>((resolve, error) => {

      // first find out if record exists.
      var found = false
      _.forEach(self.drWB_UserGroup.WB_UserGroupCustomerRows, (aUserGroupCustomerRow: WB_UserGroupCustomerRow) => {
        if (aUserGroupCustomerRow.isActive && aUserGroupCustomerRow.cif.WB_CUST_ID == aWbCustId) {
          found = true
          return false
        }
      })

      if (found) {
        resolve(self);
        return
      } // exists..
      var aCustomerRow: WB_CustomerRow = undefined

      self.dbContext.find(esWB_Customer, aWbCustId)
        .then((aCustomerRecord: WB_CustomerRow) => {
          if (_.isEmpty(aCustomerRecord)) {
            // Bad Customer ID
            resolve(self)
            return
          }
          aCustomerRow = aCustomerRecord
          // create new records
          return self.dbContext.createRecordWithKey(esWB_User_Group_Customer)
        })
        .then((aNewRow: WB_UserGroupCustomerRow) => {

          // anUserGroupCustomerRow = aNewRow
          aNewRow.cif.WB_USRGRP_ID = self.drWB_UserGroup.cif.WB_USRGRP_ID
          aNewRow.cif.WB_CUST_ID = aWbCustId
          aNewRow.cif.MANUAL_IND = '1'
          aNewRow.WB_CustomerRow = aCustomerRow
          self.dbContext.add(esWB_User_Group_Customer, aNewRow)
          resolve(self)
        })
        .catch((err) => {
          error(err)
        })
    })
  }


  removeCustomer(aWbCustId: number): Promise<IBusinessObject> {
    const self = this

    return new Promise<IBusinessObject>((resolve, error) => {

      _.forEach(self.drWB_UserGroup.WB_UserGroupCustomerRows, (aUsrGrpCustomerRow: WB_UserGroupCustomerRow) => {
        if (aUsrGrpCustomerRow.isActive && aUsrGrpCustomerRow.cif.WB_USRGRPCR_ID == aWbCustId) {
          aUsrGrpCustomerRow.markDeleted()
        }
      })

      resolve(self)
    })
  }

  addProduct(aWbPrdGrpId: number): Promise<IBusinessObject> {
    const self = this

    return new Promise<IBusinessObject>((resolve, error) => {

      // first find out if record exists.
      var found = false
      _.forEach(self.drWB_UserGroup.WB_UserGroupProductRows, (aUserGroupProdRow: WB_UserGroupProductRow) => {
        if (aUserGroupProdRow.isActive && aUserGroupProdRow.cif.WB_PRDGRP_ID == aWbPrdGrpId) {
          found = true
          return false
        }
      })

      if (found) {
        resolve(self);
        return
      } // exists..
      var aProductGroupRow: WB_ProductGroupRow = undefined

      self.dbContext.find(esWB_Product_Group, aWbPrdGrpId)
          .then((aPGRecord: WB_ProductGroupRow) => {
            if (_.isEmpty(aPGRecord)) {
              // Bad Customer ID
              resolve(self)
              return
            }
            aProductGroupRow = aPGRecord
            // create new records
            return self.dbContext.createRecordWithKey(esWB_User_Group_Product)
          })
          .then((aNewRow: WB_UserGroupProductRow) => {

            aNewRow.cif.WB_USRGRP_ID = self.drWB_UserGroup.cif.WB_USRGRP_ID
            aNewRow.cif.WB_PRDGRP_ID = aWbPrdGrpId
            aNewRow.cif.MANUAL_IND = '1'
            aNewRow.WB_ProductGroupRow = aProductGroupRow
            self.dbContext.add(esWB_User_Group_Product, aNewRow)
            resolve(self)
          })
          .catch((err) => {
            error(err)
          })
    })
  }


  removeProduct(aWbPrdGrpId: number): Promise<IBusinessObject> {
    const self = this

    return new Promise<IBusinessObject>((resolve, error) => {

      _.forEach(self.drWB_UserGroup.WB_UserGroupProductRows, (aUsrGrpProductRow: WB_UserGroupProductRow) => {
        if (aUsrGrpProductRow.isActive && aUsrGrpProductRow.cif.WB_USRGRPPR_ID == aWbPrdGrpId) {
          aUsrGrpProductRow.markDeleted()
        }
      })

      resolve(self)
    })
  }


  addUser(aWbUsrId: number): Promise<IBusinessObject> {
    const self = this

    return new Promise<IBusinessObject>((resolve, error) => {

      // first find out if record exists.
      var found = false
      _.forEach(self.drWB_UserGroup.WB_UserGroupUserRows, (aUserGroupUserRow: WB_UserGroupUserRow) => {
        if (aUserGroupUserRow.isActive && aUserGroupUserRow.cif.WB_AUTHUSR_ID == aWbUsrId) {
          found = true
          return false
        }
      })

      if (found) {
        resolve(self);
        return
      } // exists..
      var aUserRow: WB_UserRow = undefined

      self.dbContext.find(esWB_User, aWbUsrId)
        .then((aUserRecord: WB_UserRow) => {
          if (_.isEmpty(aUserRecord)) {
            // Bad Customer ID
            resolve(self)
            return
          }
          aUserRow = aUserRecord
          // create new records
          return self.dbContext.createRecordWithKey(esWB_User_Group_User)
        })
        .then((aNewRow: WB_UserGroupUserRow) => {

          aNewRow.cif.WB_USRGRP_ID = self.drWB_UserGroup.cif.WB_USRGRP_ID
          aNewRow.cif.WB_AUTHUSR_ID = aWbUsrId
          aNewRow.WB_UserRow = aUserRow
          self.dbContext.add(esWB_User_Group_User, aNewRow)
          resolve(self)
        })
        .catch((err) => {
          error(err)
        })
    })
  }

  removeUser(aWbUsrId: number): Promise<IBusinessObject> {
    const self = this

    return new Promise<IBusinessObject>((resolve, error) => {

      _.forEach(self.drWB_UserGroup.WB_UserGroupUserRows, (aUsrGrpUserRow: WB_UserGroupUserRow) => {
        if (aUsrGrpUserRow.isActive && aUsrGrpUserRow.cif.WB_AUTHUSR_ID == aWbUsrId) {
          aUsrGrpUserRow.markDeleted()
        }
      })

      resolve(self)
    })
  }

  addUserGroupR(aWbUsrGrpId: number): Promise<IBusinessObject> {
    const self = this

    return new Promise<IBusinessObject>((resolve, error) => {

      // first find out if record exists.
      var found = false
      _.forEach(self.drWB_UserGroup.WB_UserGroupRelationshipRows, (aUserGroupRRow: WB_UserGroupRelationshipRow) => {
        if (aUserGroupRRow.isActive && aUserGroupRRow.cif.WB_USRGRP_ID == aWbUsrGrpId) {
          found = true
          return false
        }
      })

      if (found) {
        resolve(self);
        return
      } // exists..
      var aUserGrpRow: WB_UserGroupRow = undefined

      self.dbContext.find(esWB_User_Group, aWbUsrGrpId)
          .then((aUserGrpRecord: WB_UserGroupRow) => {
            if (_.isEmpty(aUserGrpRecord)) {
              // Bad Customer ID
              resolve(self)
              return
            }
            aUserGrpRow = aUserGrpRecord
            // create new records
            return self.dbContext.createRecordWithKey(esWB_User_Group_Relationship)
          })
          .then((aNewRow: WB_UserGroupRelationshipRow) => {

            aNewRow.cif.WB_USRGRP_ID = aWbUsrGrpId
            aNewRow.cif.WB_USRGRP_ID_PRNT = self.drWB_UserGroup.cif.WB_USRGRP_ID
            aNewRow.WB_UserGroupRowChild = aUserGrpRow
            self.dbContext.add(esWB_User_Group_Relationship, aNewRow)
            resolve(self)
          })
          .catch((err) => {
            error(err)
          })
    })
  }

  removeUserGroupR(aWbUsrGrpRId: number): Promise<IBusinessObject> {
    const self = this

    return new Promise<IBusinessObject>((resolve, error) => {

      _.forEach(self.drWB_UserGroup.WB_UserGroupRelationshipRows, (aUsrGrpRRow: WB_UserGroupRelationshipRow) => {
        if (aUsrGrpRRow.isActive && aUsrGrpRRow.cif.WB_USRGRPR_ID == aWbUsrGrpRId) {
          aUsrGrpRRow.markDeleted()
        }
      })

      resolve(self)
    })
  }


  //</editor-fold>

  //<editor-fold desc = "IBusinessObject operations">


  Copy(options?: any): Promise<IBusinessObject> {
    return undefined;
  }

  LoadNew(options?: IUserGroupCreateOptions): Promise<IBusinessObject> {
    const self = this;
    this.LoadProgressProvider.start("Creating User Group");

    let internalOnComplete = self._OnLoadComplete = (async() => {
      try{

      self.LoadOptions = options || {};
      if ('dbContext' in self.LoadOptions)
        self.dbContext = self.LoadOptions.dbContext;
      else
        self.dbContext = new PAdbContext();

      if (this.dbContext == null) {
        var sError = "Unable to determine dbContext for new User Group.";
        self.LoadProgressProvider.exception(sError);
        return self;
      }

      // Create record using dbContext
      let newUserGroup: WB_UserGroupRow=<WB_UserGroupRow>await this.dbContext.createRecordWithKey(esWB_User_Group)
      newUserGroup.setDefaults()
      self.drWB_UserGroup = newUserGroup;
      self.dbContext.add(esWB_User_Group, newUserGroup)
      self.Identity.setAll(self.WB_UserGroup.cif.WB_USRGRP_ID, self.WB_UserGroup.cif.USRGRP_ID, self.WB_UserGroup.cif.USRGRP_NAME);
      self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
      self.LoadProgressProvider.finish();
      self._bIsLoaded = true;
      self._OnLoadComplete = null;
      await self.applyCreateOptions()
      self.Identity.setAll(self.WB_UserGroup.cif.WB_USRGRP_ID, self.WB_UserGroup.cif.USRGRP_ID, self.WB_UserGroup.cif.USRGRP_NAME);
      self.Identity.listenToRecordUpdates(self.WB_UserGroup, 'WB_USRGRP_ID', 'USRGRP_ID', 'USRGRP_NAME')

      self.LoadProgressProvider.finish();
      self._bIsLoaded = true;
      self._OnLoadComplete = null;
      return self;
      } catch(err ) {
        self.LoadProgressProvider.exception(err);
        return self
      }})();

    return internalOnComplete;
  }

  async applyCreateOptions(){
    const self = this

    let sName = self.CreateOptions?.sName || self.LoadOptions?.sName
    if (!_.isEmpty(sName))
      self.WB_UserGroup.cif.USRGRP_NAME = sName

    // Set the User Group Type
    let wbUserGroupType = self.CreateOptions?.wbUserGroupTypeID || self.LoadOptions?.wbUserGroupTypeID
    if(_.isNumber(wbUserGroupType)){
      let usrgrpType: WB_UserGroupTypeRow = <any> await self.dbContext.find(esWB_User_Group_Type,wbUserGroupType)
      if(usrgrpType){
        self.WB_UserGroup.WB_UserGroupTypeRow = usrgrpType
        self.WB_UserGroup.cif.WB_USRGRPM_ID = wbUserGroupType
        self.WB_UserGroup.cif.WB_MDSET_ID = usrgrpType.cif.WB_MDSET_ID
        let mdset: WB_MasterDataSetRow = <any> await self.dbContext.find(esWB_MasterData_Set,self.WB_UserGroup.cif.WB_MDSET_ID)
        if(mdset){
          self.WB_UserGroup.WB_UserGroupTypeRow.WB_MasterDataSetRow = mdset
        }
      }
    }

    // Set the Sales Org
    let wbSalesOrgId = self.CreateOptions?.wbSalesOrgId || self.LoadOptions?.wbSalesOrgId
    if(_.isNumber(wbSalesOrgId)){
      let salesOrg: WB_SalesOrgRow = <any> await self.dbContext.find(esWB_SalesOrg, wbSalesOrgId)
      if(salesOrg){
        self.WB_UserGroup.cif.WB_SALESORG_ID = wbSalesOrgId
        self.WB_UserGroup.WB_SalesOrgRow = salesOrg
      }
    }


  }

  Load(anId: number | number, options?: IUserGroupCreateOptions): Promise<IBusinessObject> {

    const self = this;

    let recordResolver: ESRecordResolver
    let recordResolverLoadPromise: Promise<void>

    self.LoadProgressProvider.start("Loading (" + anId + ")");

    self._OnLoadComplete = new Promise<IBusinessObject>((resolve, error) => {

      if (self.bIsLoaded) {
        self.LoadProgressProvider.exception("User Group already loaded.")
        resolve(self); // "User Group already loaded.";
        return;
      }

      self.LoadOptions = options || {};
      _.defaults(self.LoadOptions, UserGroupLoadOptions_default)


      if ('dbContext' in self.LoadOptions)
        self.dbContext = self.LoadOptions.dbContext;
      else if (_.isEmpty(self.dbContext)) {
        self.dbContext = new PAdbContext({});
      }

      if (_.isEmpty(self.dbContext)) {
        error("Unable to determine dbContext for User Group.")
        return;
      }

      if ('RecordResolver' in self.LoadOptions) {
        recordResolver = (<any>self.LoadOptions).RecordResolver
        recordResolverLoadPromise = ASync.resolve()
      } else {
        recordResolver = UserGroupBO.createRecordResolver({dbContext: self.dbContext})
        recordResolverLoadPromise = UserGroupBO.setupRecordResolver(recordResolver, [anId])
      }


      recordResolverLoadPromise
        .then(function () {
          let aUserGroupRow: any = recordResolver.get(esWB_User_Group, anId)

          if (_.isEmpty(aUserGroupRow)) {
            error("User Group not Found");
            return;
          }

          self.drWB_UserGroup = aUserGroupRow;
          self.Identity.setAll(self.WB_UserGroup.cif.WB_USRGRP_ID, self.WB_UserGroup.cif.USRGRP_ID, self.WB_UserGroup.cif.USRGRP_NAME);
          self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
          self.Identity.listenToRecordUpdates(self.WB_UserGroup, 'WB_USRGRP_ID', 'USRGRP_ID', 'USRGRP_NAME')
          self._bIsLoaded = true
          self._OnLoadComplete = undefined
          self.LoadProgressProvider.finish()
          resolve(self)
        }).catch(function (err: any) {
        self._OnLoadComplete = undefined
        self.LoadProgressProvider.exception(err)
        error(err)
        return;
      });

    });

    return this._OnLoadComplete;
  }

  get OnLoadComplete(): Promise<IBusinessObject> {
    return this._OnLoadComplete;
  }

  get bIsLoaded(): boolean {
    return this._bIsLoaded;
  }

  Validate(options?: any): Promise<IBusinessObject> {

    var self = this;
    this.ValidateMessageProvider.clearMessages();
    this.ValidateProgressProvider.start("Validating " + self.WB_UserGroup.cif.USRGRP_NAME + "(" + self.WB_UserGroup.cif.USRGRP_ID + ")");
    return new Promise<IBusinessObject>((resolve, reject) => {
      // Does no validations yet
      self.ValidateOptions = options || {};

      if (self.dbContext == undefined) {
        var sError = "Unable to determine dbContext for to Validate User Group.";
        self._bIsValidated = false;
        self.ValidateProgressProvider.exception(sError);
        reject(sError);
        return
      }

      UserGroupBOValidations.Validate(self)
          .then((ignore) => {
            //return  next validation
            // ()then hanadler

            if (self.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
              self._bIsValidated = false;
            } else {
              self._bIsValidated = true;
            }
            self.ValidateProgressProvider.finish();
            resolve(self);

          })
          .catch((err) => {
            self._bIsValidated = false;
            self.ValidateProgressProvider.exception(err);
            resolve(self);

          })
    });
  }

  get bIsValidated(): boolean {
    return this._bIsValidated;
  }


  Save(options?: any): Promise<IBusinessObject> {
    return this.SaveUsing(false, options)
  }


  SaveBatch(options?: any): Promise<IBusinessObject> {
    return this.SaveUsing(true, options)
  }

  SaveUsing(bBatch: boolean, options?: any): Promise<IBusinessObject> {

    var self = this;
    var wbUsrGrp = <IwbUserGroup>self.drWB_UserGroup;
    let auditService: AuditService = undefined
    // this.SaveProgressProvider.start("Saving " + wbUsrGrp.USRGRP_NAME + "(" + wbUsrGrp.USRGRP_ID + ")");

    return new Promise<IBusinessObject>((resolve, reject) => {
      // Doesn't need to do anything yet
      // All the records are in the store, since they were added through find or createNewRecord.
      // -- We could search the tree if the there is any record where store isn't set.

      if (self.dbContext == undefined) {
        self._bIsSaved = false;
        var sError = "Unable to determine dbContext to Save User Group.";
        self.SaveProgressProvider.exception(sError);
        reject(sError);
        return
      }

      self.SaveOptions = options || {};
      var saveFunction: (esName: string, saveRecords: ESRecord[] | ESRecord, options?: any) => Promise<ESDataStore>
      if (bBatch) {
        saveFunction = self.dbContext.SaveBatch.bind(self.dbContext)
      } else {
        saveFunction = self.dbContext.Save.bind(self.dbContext)
      }

      let bDone = false
      self.Validate({})
        .then((ignore) => {
          if (self.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
            self._bIsSaved = false;
            self.SaveProgressProvider.finish();
            bDone = true
            resolve(self);
            return
          }
        })
        .then((ignore) => {
          if (bDone) return
          // Do Audit Logging
          return UserGroupBOAudit.UserGroupAuditBO(self)
        })
          .then((anAuditService) => {
            if (bDone) return
            auditService = anAuditService
            return saveFunction(esWB_User_Group, self.drWB_UserGroup, {})
          })
        .then((ignore) => {
          if (bDone) return

          // Do saving
          var tasks: Promise<any>[] = []
          tasks.push(saveFunction(esWB_User_Group_Customer, self.drWB_UserGroup.WB_UserGroupCustomerRows))
          tasks.push(saveFunction(esWB_User_Group_Product, self.drWB_UserGroup.WB_UserGroupProductRows))
          tasks.push(saveFunction(esWB_User_Group_User, self.drWB_UserGroup.WB_UserGroupUserRows))
          tasks.push(saveFunction(esWB_User_Group_Role, self.drWB_UserGroup.WB_UserGroupRoleRows))
          tasks.push(saveFunction(esWB_User_Group_Relationship, self.drWB_UserGroup.WB_UserGroupRelationshipRows))
          tasks.push(saveFunction(esWB_User_Group_Type, self.drWB_UserGroup.WB_UserGroupTypeRow))
          tasks.push(saveFunction(esWB_User_Group_SalesArea, self.drWB_UserGroup.WB_UserGroupSalesAreaRows))
          return Promise.all(tasks)
        }).then((ignored) => {
        if (auditService) {
          return auditService.Save(bBatch)
        }
      })
        .then((ignored) => {
          if (bDone) return
          if (bBatch) {
            self.dbContext.addBatchCompleteListener(() => {
              self._bIsSaved = true;
              LeaseRegistry.generateLeaseInvalidationByClass(LeaseRegistry.Lease_Type_DimensionHierarchy);
            })
          } else {
            self._bIsSaved = true;
            LeaseRegistry.generateLeaseInvalidationByClass(LeaseRegistry.Lease_Type_DimensionHierarchy);
          }
          self.SaveProgressProvider.finish();
        })
        .then((ignored) => {
          resolve(self);
        })
        .catch((err) => {
          self.SaveProgressProvider.exception(err);
          resolve(self)
        })

    })
  }

  get bIsSaved(): boolean {
    return this._bIsSaved;
  }

//Delete------------------------------------------------------------------------
  Delete(options?: any): Promise<IBusinessObject> {
    return this.DeleteUsing(true, options)
  }

  DeleteOnSave(options?: any): Promise<IBusinessObject> {
    return this.DeleteUsing(false, options)
  }

  private DeleteUsing(bSaveNow: boolean, options?: any): Promise<IBusinessObject> {
    var self = this;
    var wbUsrGrp = <IwbUserGroup>self.drWB_UserGroup;
    this.DeleteMessageProvider.clearMessages();
    this.DeleteProgressProvider.start("Deleting " + wbUsrGrp.USRGRP_NAME + "(" + wbUsrGrp.WB_USRGRP_ID + ")");
    return new Promise<IBusinessObject>((resolve, error) => {

      // 1. Validate if we can delete the User Group

      // 2. If Valid, mark all the records for deletion.
      self.drWB_UserGroup.markDeleted()
      _.forEach(self.drWB_UserGroup.WB_UserGroupCustomerRows, (aRow) => {
        aRow.markDeleted()
      })
      _.forEach(self.drWB_UserGroup.WB_UserGroupRoleRows, (aRow) => {
        aRow.markDeleted()
      })
      _.forEach(self.drWB_UserGroup.WB_UserGroupUserRows, (aRow) => {
        aRow.markDeleted()
      })

      if (bSaveNow) {
        self.SaveUsing(false)
          .then((ignore) => {
            self._bIsDeleted = true;
            self.DeleteProgressProvider.finish();
            resolve(self);

          })
          .catch((err) => {
            this.DeleteProgressProvider.exception(err)
            resolve(self)
          })
      } else {
        self._bIsDeleted = true;
        self.DeleteProgressProvider.finish();
        resolve(self);
      }
    });
  }

  get bIsDeleted(): boolean {
    return this._bIsDeleted;
  }

  //</editor-fold>

  //<editor-fold desc = "Sales Area">

  _salesAreasChanged: BehaviorSubject<UserGroupBO>

  IHaveSalesAreas_init() {
    this._salesAreasChanged = new BehaviorSubject<UserGroupBO>(this)
  }

  get SalesAreasChanged(): BehaviorSubject<UserGroupBO> {
    return this._salesAreasChanged
  }

  async addSalesArea(wbSalesAreaId: number): Promise<WB_UserGroupSalesAreaRow> {
    const self = this

    for (let rel of self.WB_UserGroup.WB_UserGroupSalesAreaRows) {
      if (!rel.isActive)
        continue
      if (rel.cif.WB_SALESAREA_ID == wbSalesAreaId)
        return rel
    }

    let saRow: WB_SalesAreaRow = await self.dbContext.find(esWB_SalesArea, wbSalesAreaId)
    if (_.isEmpty(saRow))
      return undefined

    if (saRow.cif.WB_SALESORG_ID > 0) {
      let soRow: WB_SalesOrgRow = <any>await self.dbContext.find(esWB_SalesOrg, saRow.cif.WB_SALESORG_ID)
      if (!_.isEmpty(soRow) && _.isEmpty(saRow.WB_SalesOrgRow)) {
        saRow.WB_SalesOrgRow = soRow
      }
    }

    if (saRow.cif.WB_DIVISION_ID > 0) {
      let dvRow: WB_DivisionRow = <any>await self.dbContext.find(esWB_Division, saRow.cif.WB_DIVISION_ID)
      if (!_.isEmpty(dvRow) && _.isEmpty(saRow.WB_DivisionRow)) {
        saRow.WB_DivisionRow = dvRow
      }
    }

    if (saRow.cif.WB_DISTRIBCHANNEL_ID > 0) {
      let dcRow: WB_DistribChannelRow = <any>await self.dbContext.find(esWB_DistribChannel, saRow.cif.WB_DISTRIBCHANNEL_ID)
      if (!_.isEmpty(dcRow) && _.isEmpty(saRow.WB_DistribChannelRow)) {
        saRow.WB_DistribChannelRow = dcRow
      }
    }

    let newRow: WB_UserGroupSalesAreaRow = <any>await self.dbContext.createRecordWithKey(esWB_User_Group_SalesArea)
    newRow.setDefaults()
    newRow.WB_UserGroupRow = self.WB_UserGroup
    newRow.cif.WB_USRGRP_ID = self.WB_UserGroup.cif.WB_USRGRP_ID
    newRow.WB_SalesAreaRow = saRow
    newRow.cif.WB_SALESAREA_ID = wbSalesAreaId

    self.SalesAreasChanged.next(self)
    return newRow
  }

  async removeSalesArea(wbSalesAreaId: number): Promise<void> {
    const self = this

    for (let rel of self.WB_UserGroup.WB_UserGroupSalesAreaRows) {
      if (!rel.isActive)
        continue
      if (rel.cif.WB_USRGRPSAR_ID == wbSalesAreaId) {
        rel.markDeleted()
        break
      }
    }

    self.SalesAreasChanged.next(self)
  }


  //</editor-fold>

  Changes(options?: IBusinessObjectChangesOptions): IBusinessObjectChanges {
    let opts = options || {}
    // Set any BO Specific change settings
    return DefaultChanges(this, this.drWB_UserGroup, opts)
  }

  //<editor-fold desc = "IRecordResolver Operations">

  static setupRecordResolver(recordResolver: ESRecordResolver, ids: string[] | number[]): Promise<void> {

    return new Promise<void>((resolve, error) => {
      recordResolver.findAllWithRelationships(esWB_User_Group, ids).then((result) => {
        resolve()
      }).catch((err) => {
        error(err)
      })
    })
  }

  static concurrentLoadCountHint(): number {
    return 10;
  }

  static createRecordResolver(boLoadOptions: any): ESRecordResolver {

    let opts = boLoadOptions || {}
    let dbContext: PAdbContext

    if ('dbContext' in opts) {
      dbContext = opts.dbContext;
    } else {
      dbContext = new PAdbContext({});
    }
    const wrksp_options: CreateOptions = {
      standardConditions: {
        [esWB_Customer]: {"DELETED_IND": {"notIn": ['1']}},
        [esWB_Domain_Item]: {"DELETED_IND": {"notIn": ['1']}},
        [esWB_User]: {"DELETED_IND": {"notIn": ['1']}},
        [esWB_User_Group]: {"DELETED_IND": {"notIn": ['1']}},
        [esWB_User_Group_Customer]: {"DELETED_IND": {"notIn": ['1']}},
        [esWB_User_Group_Role]: {"DELETED_IND": {"notIn": ['1']}},
        [esWB_User_Group_User]: {"DELETED_IND": {"notIn": ['1']}},
      },
      dctIncludeBelongsToNamedRelations: {},
      dctExcludeHasManyNamedRelations: {
        [esWB_Customer]: [esWB_Customer_SalesArea_Relationship]
      }
    }

    const aRecResolver = new ESRecordResolver(dbContext, wrksp_options)

    return aRecResolver;

  }

  //</editor-fold>


};
PAEnvironment.registerBusinessObjectClass( UserGroupBO , "UserGroupBO", "User Group")